import { useT } from "@transifex/react";
import PhaseSixIcon from "../../basic/phaseSixIcon/PhaseSixIcon";

interface ClassroomPreviewBannerProps {
    onExit: () => void;
}

const ClassroomPreviewBanner = (props: ClassroomPreviewBannerProps) => {
    const t = useT();

    const t_previewMode = t("Preview mode", { _tags: "ClassMemberDashboard, ClassroomPreviewBanner" });
    const t_sr_exitPreview = t("Exit preview mode", {
        _tags: "ClassMemberDashboard, ClassroomPreviewBanner, ScreenReaderOnly",
    });

    return (
        <div className="sticky top-[60px] z-[999] w-full flex items-center justify-between gap-s bg-p6-orange px-m py-s">
            <div className="flex items-center gap-xs">
                <PhaseSixIcon
                    name="preview"
                    className="text-header-icon text-white"
                />
                <span className="text-l font-semibold text-white uppercase">{t_previewMode}</span>
            </div>
            <button
                type="button"
                aria-label={t_sr_exitPreview}
                onClick={props.onExit}
                className="flex items-center justify-center min-w-[44px] min-h-[44px] bg-transparent cursor-pointer"
            >
                <PhaseSixIcon
                    name="close"
                    className="text-header-icon text-white"
                />
            </button>
        </div>
    );
};

export default ClassroomPreviewBanner;
